export default {
  title: '编写新信息',
  label: {
    subject: '主题',
    content: '内容'
  },
  btn: {
    send: '发送信息'
  },
  message: {
    sendSuccess: '发送成功',
    noEmailAccount: '该用户没有填写邮箱，我们暂时无法邀请该求职者。短信邀请正在紧张制作中，敬请期待！',
    sendFail: '发送失败'
  }
}
